import { gql } from "lib/apolloClient";

export const teacherItemDetailFragment = {
  teacherItemDetails: gql`
    fragment teacherItemDetail on Staff {
      id
      firstName
      lastName
      middleName
      profileImage
      pronouns
      preferredName
      prefix
      suffix
      email
      designation {
        id
        __typename
      }
      courses(filters: $courseFilters) {
        id
        title
      }
      __typename
    }
  `,
};
export const staffPermissionFragments = {
  staffPermissions: gql`
    fragment staffPermissions on Staff {
      entityRelationMap(filters: $entityRelationMapFilters) {
        edges {
          node {
            relatedEntity {
              ... on Staff {
                id
                firstName
                lastName
                middleName
                email
                isArchived
                profileImage
                pronouns
                preferredName
                prefix
                suffix
              }
            }
            relationType
            entityType
            relatedEntityType
          }
          cursor
        }
      }
      permissions(
        curriculumProgramId: $permissionCurriculumId
        configurations: ["StaffPermission:PortfolioReviewer"]
      ) {
        configuration {
          configurations {
            id
            configuration
            valueType
            value
            __typename
          }
          __typename
        }
        __typename
      }
      __typename
    }
  `,
};

export const basicUserFragment = gql`
  fragment basicUserItem on User {
    id
    type
    firstName
    middleName
    lastName
    profileImage
    ... on Staff {
      preferredName
      prefix
      suffix
      pronouns
    }
  }
`;
